var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSucces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#E8FAF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#D1F2E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6668 18C24.6668 21.6819 21.6821 24.6667 18.0002 24.6667C14.3183 24.6667 11.3335 21.6819 11.3335 18C11.3335 14.3181 14.3183 11.3334 18.0002 11.3334C21.6821 11.3334 24.6668 14.3181 24.6668 18ZM20.687 15.9798C20.8823 16.1751 20.8823 16.4917 20.687 16.6869L17.3537 20.0203C17.1585 20.2155 16.8419 20.2155 16.6466 20.0203L15.3133 18.6869C15.118 18.4917 15.118 18.1751 15.3133 17.9798C15.5085 17.7846 15.8251 17.7846 16.0204 17.9798L17.0002 18.9596L18.4901 17.4697L19.9799 15.9798C20.1752 15.7846 20.4918 15.7846 20.687 15.9798Z",
    fill: "#0E793C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSucces);
export default __webpack_public_path__ + "static/media/icon-succes.d1c570d3a055b4261119f5c18f289520.svg";
export { ForwardRef as ReactComponent };